// test1745
(1745 && 0);
